import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/services/core/auth/auth.service';
import { MMobileHelperService } from '../../../core/services/core/mmobile-helper.service';
import { UrlHelper } from '../../../core/services/helpers/url-helper.service';
import { PatrimonialService } from '../../../core/services/http-services/patrimonial.service';

@Component({
  selector: 'app-pwa-patrimonials-footer',
  templateUrl: './pwa-patrimonials-footer.component.html',
  styleUrls: ['./pwa-patrimonials-footer.component.scss']
})
export class PwaPatrimonialsFooterComponent implements OnInit {
  constructor(
    public auth: AuthService,
    public patrimonialService: PatrimonialService,
    private url: UrlHelper,
    private mmobileHelper: MMobileHelperService
  ) {}

  ngOnInit() {}

  onOpenRGPDUEWeb() {
    const url = this.mmobileHelper.getCustomConfigData('policyGeneric', 'URL');
    this.url.open(url);
  }

  onOpenMapfreWeb() {
    this.url.open('https://www.mapfre.es/particulares/');
  }
}
